<script setup lang="ts">
// Shell shared by every guide: heading and optional Drive video. Style the slotted content with the
// `docs-steps`, `docs-note`, `docs-link` and `docs-kbd` shortcuts from uno.config.ts.
const props = defineProps<{
  id: string
  title: string
  subtitle: string
  icon: string
  videoId?: string
}>()

const embedUrl = computed(() => props.videoId && `https://drive.google.com/file/d/${props.videoId}/preview`)
</script>

<template>
  <section :id="id" class="mt-12 pt-8 border-t border-black/10 scroll-mt-18 lg:scroll-mt-4">
    <h2 class="typo-serif-2 mb-4 flex gap-3 items-center">
      <span class="flex-none size-8 icon" :class="icon" aria-hidden="true" />
      <span>
        {{ title }}
        <span class="typo-sans-1 c-black/50 mt-1 block">{{ subtitle }}</span>
      </span>
    </h2>

    <div v-if="embedUrl" class="rounded-2.5 bg-linen aspect-video relative overflow-hidden">
      <iframe
        :src="embedUrl"
        :title="`${title} – ${subtitle}`"
        allow="autoplay; fullscreen"
        allowfullscreen
        loading="lazy"
        class="border-0 size-full inset-0 absolute"
      />
    </div>

    <slot />
  </section>
</template>
